import { render, staticRenderFns } from "./DetailPenerbitanBerusaha.vue?vue&type=template&id=a0147d16&"
import script from "./DetailPenerbitanBerusaha.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanBerusaha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports